"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var conditionFilter = function conditionFilter(condition) {
  var identifier = condition.identifier,
    importance = condition.importance,
    name = condition.name;
  var slug = identifier === null || identifier === void 0 ? void 0 : identifier.current;
  var isHighImportance = importance === 'high';
  var isIncluded = !(0, _fp.includes)(slug, ['promo-code', 'join-end-date']);
  return isHighImportance && isIncluded && name ? {
    value: name
  } : null;
};
var _default = exports["default"] = conditionFilter;
module.exports = exports.default;